import { defineComponent as _defineComponent } from 'vue'
import { useBreakpoint, useSearch } from '~/composables';

interface Emits {
  (e: 'close'): void;
  (e: 'search', value: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppSearch',
  emits: ["close", "search"],
  setup(__props, { emit }: { emit: ({
  (e: 'close'): void;
  (e: 'search', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');
const {
  searchValue,
  popularSearches,
  searchType,
  searchProducts,
  searchDocuments,
  updateRouter,
} = useSearch();



const close = () => emit('close');

const doSearch = async () => {
  if (!searchValue.value) return;
  close();

  if (searchType.value) updateRouter(searchType.value);
  else
    searchType.value === 'documents'
      ? await searchDocuments()
      : await searchProducts();
};

const selectSearchResult = (value: string) => {
  searchValue.value = value;
  doSearch();
};

return { __sfc: true,isDesktop, searchValue, popularSearches, searchType, searchProducts, searchDocuments, updateRouter, emit, close, doSearch, selectSearchResult }
}

})